import PropTypes from 'prop-types';
import { useUser } from '../../context/user';
import NavigationBar from '../NavigationBar';
import { useHistory } from 'react-router-dom';
import castlogo from '../../resources/castlogo.png';
import {
  Wrapper,
  HeaderWrapper,
  LogoAndTitleWrapper,
  Logo,
  TitlesWrapper,
  MainTitle,
  UserAreaWrapper,
  UserWrapper,
  Username,
  UserImagePlaceholder,
  LogoutButton,
  CastLogo,
  // UserOptionsList, TODO
  // UserOption, TODO
} from './styles';

// import Tooltip from '../ToolTip'; TODO
function Header({ title, logo, logoutUser }) {
  let history = useHistory();
  const userMenuOptions = [
    {
      name: 'logout',
      onClick: logoutUser,
    },
  ];

  const { user } = useUser();

  const goHome = () => {
    history.push('/home');
  };

  return (
    <Wrapper>
      <HeaderWrapper>
        <TitlesWrapper>
          <LogoAndTitleWrapper onClick={goHome}>
            {logo && <Logo src={logo} />}
            <CastLogo src={castlogo}/>
            <MainTitle>{title}</MainTitle>
          </LogoAndTitleWrapper>
        </TitlesWrapper>
        <UserAreaWrapper>
          <UserWrapper>
            <LogoutButton
              onClick={userMenuOptions[0].onClick}
              title={userMenuOptions[0].name}
              type='transparentBackgroundButton'
            />
            <Username>{user ? `${user.name}` : ''}</Username>
            <UserImagePlaceholder />
            {/* <Tooltip TODO
            triggerComponent={
              <UserImage
                src={
                  'https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350'
                }
              />
            }
            contentComponent={
              <UserOptionsList>
                {userMenuOptions.map((option) => (
                  <UserOption onClick={option.onClick} key={Math.random()}>
                    {option.name}
                  </UserOption>
                ))}
              </UserOptionsList>
            }
          /> */}
          </UserWrapper>
        </UserAreaWrapper>
      </HeaderWrapper>
      <NavigationBar />
    </Wrapper>
  );
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  logo: PropTypes.node,
};

Header.defaultProps = {};

export default Header;
